import {
	SET_PLACES,
	SET_PACKAGE,
	SET_GENEROS,
	SET_SERVICES,
	SET_LOCALFORAGE_LOADED
} from '../actions/Types';

const INITIAL_STATE = {
	localforageLoaded: false,
	places: [],
	package: {},
	generos: [],
	services: []
}

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SET_PLACES:
			return { ...state, places: action.payload };
		case SET_PACKAGE:
			return { ...state, package: action.payload };
		case SET_GENEROS:
			return { ...state, generos: action.payload };
		case SET_SERVICES:
			return { ...state, services: action.payload };
		case SET_LOCALFORAGE_LOADED:
			return { ...state, localforageLoaded: action.payload };
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/PackageReducer.js